import { crimson } from './fonts'

export function DeluxeBooksSuccess() {
  return (
    <div
      className="max-w-2xl mx-auto rounded-lg px-6 py-6 text-center text-white shadow-md"
      style={{
        background: 'linear-gradient(135deg, #d4af37 0%, #b8941f 100%)',
      }}
    >
      <p className={`${crimson.className} text-lg`}>
        <strong>
          Perfect! We&apos;ll notify you as soon as new deluxe editions become
          available.
        </strong>
      </p>
    </div>
  )
}
